export default "__VITE_ASSET__DkXwkaQx__"